import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'paf-result-footpath.scss',
  tag: 'paf-result-footpath',
})

export class PafResultFootpath implements ComponentInterface {

  /** Time to show as footpath */
  @Prop() public time!: number;

  /** Description to show */
  @Prop() public description!: string;

  /** Assistive text for the time */
  @Prop() public timeAssistiveText!: string;

  /** Show wheelchair icon instead of walking person */
  @Prop() public wheelchair?: boolean;

  public render(): HTMLDivElement {
    let viewBoxDefinition = '0 0 10 16';
    let svgContent = 'M4.5 1c-.257 0-.5.243-.5.5s.243.5.5.5.5-.243.5-.5-.243-.5-.5-.5ZM3 1.5C3 .69 3.69 0 4.5 0S6 .69 6 1.5 5.309 3 4.5 3 3 2.31 3 1.5ZM4 5v4h1V5H4Zm-1 .434v6.914l-1.916 2.874.832.555 2-3L4 12.651V10h1.293L7 11.707V16h1v-4.707l-.146-.147L6 9.293V5.707l1.146 1.146.147.147H10V6H7.707L5.854 4.146 5.707 4H3.35l-.126.084-3 2L0 6.232V10h1V6.767l2-1.333Z';

    if (this.wheelchair) {
      viewBoxDefinition = '0 0 24 24';
      svgContent = 'M10.5 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.5 8.5V8h1v5h5v6h-1v-5h-5zm-3.995 1c0-1.75 1.01-3.27 2.471-4.014l.454.891A3.51 3.51 0 0 0 7.005 14.5c0 1.922 1.578 3.5 3.5 3.5 1.39 0 2.605-.826 3.168-2.018l.904.428A4.52 4.52 0 0 1 10.505 19a4.514 4.514 0 0 1-4.5-4.5';
    }

    return (
      <div class='footpath'>
        <span class='time'>{this.time}
          <span
            aria-hidden='true'
            role='presentation'
          >’</span>
          <span class='time-hidden-text'>{this.timeAssistiveText}</span>
        </span>
        <svg
          class={{
            'icon': true,
            'icon--wheelchair': this.wheelchair,
          }}
          viewBox={viewBoxDefinition}
        >
          <path fill-rule='evenodd' d={svgContent} clip-rule='evenodd'/>
        </svg>
        <span class='description'>{this.description}</span>
      </div>
    );
  }
}
